import { jsx as _jsx } from "react/jsx-runtime";
// Force the fill/border to survive print + Gotenberg (Chromium drops
// backgrounds in print by default).
const PRINT_EXACT = {
    printColorAdjust: 'exact',
    WebkitPrintColorAdjust: 'exact',
};
/**
 * Shared checkbox glyph for templates. Checked = filled dark box with a
 * white tick (high contrast, reliably visible in PDF/preview); unchecked =
 * bordered empty box. Replaces the faint per-template `✓`-in-thin-border
 * definitions. Sized to sit inline with `text-[10.5px]` body copy.
 */
export function Checkbox({ checked }) {
    return (_jsx("span", { className: 'mr-1 inline-flex h-3.5 w-3.5 items-center justify-center rounded-[2px] border align-middle text-[10px] font-bold leading-none ' +
            (checked
                ? 'border-stone-800 bg-stone-800 text-white'
                : 'border-stone-500 text-transparent'), style: PRINT_EXACT, "aria-hidden": true, children: "\u2713" }));
}
//# sourceMappingURL=Checkbox.js.map